import { render } from "./GridLinkComponent.vue?vue&type=template&id=6b345d02"
import script from "./GridLinkComponent.vue?vue&type=script&lang=js"
export * from "./GridLinkComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__